import React from "react";
import { ReactNode } from "react";
import { UserProvider } from "./UserProvider";
import { PurchasedPatternsProvider } from "./PurchasedPatternsProvider";
import { AuthProvider } from "./AuthProvider";
import { CartProvider } from "./CartProvider";
import { CurrencyProvider } from "./CurrencyProvider";

interface ContextProviderProps {
  children: ReactNode;
}

const ContextProvider: React.FC<ContextProviderProps> = ({ children }) => {
  return (
    <AuthProvider>
      <UserProvider>
        <PurchasedPatternsProvider>
          <CurrencyProvider>
            <CartProvider>{children}</CartProvider>
          </CurrencyProvider>
        </PurchasedPatternsProvider>
      </UserProvider>
    </AuthProvider>
  );
};

export default ContextProvider;
